/* eslint-disable no-unused-expressions */
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  Login, Options, Layout, UploadPage, Review, ErrorPage, ChoosePage, Feedback, NotFound,
  Payment, OldLogin, ReturnMethod, Unfulfilled, ReturnLoginPage,
  SuccessPage, ForbiddenPage,
} from '@pages';
import ChoosePackage from '@pages/dhgate/choose-package';
import ChooseItems from '@pages/dhgate/choose-items';
import DhgateOptions from '@pages/dhgate/options';
import DhgatePayment from '@pages/dhgate/payment';
import DhgateReview from '@pages/dhgate/review';
import DhgateUpload from '@pages/dhgate/upload';
import './App.css';
import { useEffectOnce, useValidateUser } from '@hooks';
import {
  ROUTE_ARR, dhgate,
} from '@constants/claim';
import { Loading } from '@/general';

function App() {
  // 调用自定义 Hook
  const {
    isValidUser, loading, rcV4User, oldUrlRedirect,
  } = useValidateUser();

  useEffectOnce(async () => {
    const { isValid, isChannel } = await rcV4User();
    if (!isValid) {
      oldUrlRedirect(isChannel);
    }
  }, []);

  if (loading) {
    return (
      <Loading />
    ); // 显示加载状态
  }

  return (
    <div className="App">
      <Routes>
        <Route path="403" element={<ForbiddenPage code={403} />} />
        {isValidUser ? (
          <Route path=":store_name" element={<ReturnLoginPage />} />
        ) : (
          <>
            <Route path="motosports/*" element={<Navigate to="/motosport" replace />} />
            <Route path="*" element={<NotFound />} />
            {ROUTE_ARR.map((path) => (
              <Route path={path} key={path} element={<Layout />}>
                <Route index element={<Login />} />
                <Route path="options" element={<Options />} />
                <Route path="choose" element={<ChoosePage />} />
                <Route path="upload" element={<UploadPage />} />
                <Route path="review" element={<Review />} />
                <Route path="feedback" element={<Feedback />} />
                <Route path="payment" element={<Payment />} />
                <Route path="return_method" element={<ReturnMethod />} />
                <Route path="error" element={<ErrorPage />} />
                <Route path="return/*" element={<OldLogin />} />
                <Route path="unfulfilled" element={<Unfulfilled />} />
                <Route path="success" element={<SuccessPage />} />
              </Route>
            ))}
            <Route path={`/${dhgate}`} element={<Layout />}>
              <Route index element={<Login />} />
              <Route path="options" element={<DhgateOptions />} />
              <Route path="choose-package" element={<ChoosePackage />} />
              <Route path="choose-items" element={<ChooseItems />} />
              <Route path="upload" element={<DhgateUpload />} />
              <Route path="review" element={<DhgateReview />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="payment" element={<DhgatePayment />} />
              <Route path="return_method" element={<ReturnMethod />} />
              <Route path="error" element={<ErrorPage />} />
            </Route>
            <Route path=":dynamic_domain" element={<Layout />}>
              <Route index element={<Login />} />
              <Route path="options" element={<Options />} />
              <Route path="choose" element={<ChoosePage />} />
              <Route path="upload" element={<UploadPage />} />
              <Route path="review" element={<Review />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="payment" element={<Payment />} />
              <Route path="return_method" element={<ReturnMethod />} />
              <Route path="error" element={<ErrorPage />} />
            </Route>
          </>
        )}
      </Routes>
    </div>
  );
}

export default App;
